export default {
  error_alert: {
    pt: 'Houve um problema com o seu envio de fotos:',
    en: 'There is an error with your media submit:'
  },
  limit_available: {
    pt: 'Você deve enviar mais',
    en: 'You have to send more'
  },
  album: {
    pt: 'Álbum',
    en: 'Album'
  },
  entry: {
    pt: 'Entrada',
    en: 'Entry'
  },
  already_confirmed: {
    pt: 'Este álbum já foi enviado e está confirmado para o concurso!',
    en: 'This album has already been sent and it\'s confirmed for the contest!'
  },
  not_confirmed: {
    pt: 'Este álbum não está confirmado por pendência de pagamento.',
    en: 'This album is not confirmed due to pending payment.'
  },
  discart_album: {
    pt: 'Descartar álbum',
    en: 'Discard album'
  },
  album_title_label: {
    pt: 'Título do trabalho',
    en: 'Album\'s title'
  },
  album_location_label: {
    pt: 'Cidade e país',
    en: 'City and country'
  },
  pictures: {
    pt: 'fotos',
    en: 'photos'
  },
  limit_reached: {
    pt: 'Você enviou o total de imagens para o álbum',
    en: 'You have uploaded the total images to the album'
  },
  submit_pictures: {
    pt: 'Enviar fotos',
    en: 'Submit pictures'
  },
  photos_alert: {
    pt: 'Imagens devem ser na extenção .jpg e nas dimensões 1200x800 pixels.',
    en: 'Images must be .jpg and 1200x800 pixels.'
  },
  tutorial_link: {
    pt: 'Dúvidas sobre como redimensionar? Assista o tutorial aqui.',
    en: 'Need help to resize the pictures? Watch the guide here.'
  },
  remove_photo: {
    pt: 'Remover foto',
    en: 'Remove photo'
  },
  file: {
    pt: 'Arquivo',
    en: 'File'
  },
  requirements: {
    pt: 'fora dos requerimentos',
    en: 'does not meet the requirements'
  },
  submit_limit: {
    pt: 'Limite de envio de imagens é de',
    en: 'Image upload limit is'
  },
  files: {
    pt: 'arquivos',
    en: 'files'
  },
  rules_required: {
    pt: 'Campo obrigatório.',
    en: 'Required field.'
  },
  album_category: {
    pt: 'Categoria do álbum',
    en: 'Album\'s category'
  },
  wedding_album: {
    pt: 'Álbum de casamento',
    en: 'Wedding album'
  },
  pre_wedding_album: {
    pt: 'Álbum de pré-casamento',
    en: 'Pre-wedding album'
  },
  complete_collection: {
    pt: 'Coleção completa com as 20 fotos.',
    en: 'Complete collection with 20 photos.'
  }
}
